var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'be-loading': true, 'be-loading-active': _vm.active }},[_vm._t("default"),_c('be-spinner')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }